
    <div class="ui-dialog-title clearfix">
        {{if IsMobileOk==false}}
        <!--未绑定 -->
            <p>绑定手机号</p>
        {{else}}
            <p>更换手机号</p>
        {{/if}}
    </div>
    <div class="clearfix">
        <form class="layui-form" style="padding: 0 70px; text-align: center">
            <div class="form-data-item clearfix">
                <div class="form-block fl">
                    <input type="text" style="width: 80px" value="+86" readonly />
                </div>
                <div class="form-block fr">
                    <input type="text" id="setNewPhone" style="width: 230px;" placeholder="请输入手机号" maxlength="11" onkeyup="this.value=this.value.replace(/[^\d]/g,'') " onafterpaste="this.value=this.value.replace(/[^\d]/g,'')" />
                </div>
            </div>
            <div class="form-data-item clearfix">
                <div class="form-block fl">
                    <input class="fl" type="text" id="setTextCode" style="width: 220px;" placeholder="请输入短信验证码" maxlength="6" onkeyup="this.value=this.value.replace(/[^\d]/g,'') " onafterpaste="this.value=this.value.replace(/[^\d]/g,'')" />
                </div>
                <div class="form-block fr">
                    <button class="fr" type="button" id="getVerBtn" style="width: 90px;">获取验证码</button>
                </div>
            </div>
        </form>
    </div>
    <div class="btn-wrap" style="">
        <a class="btn-save w180btn themeColor" id="confirmBind" onclick="">确认</a>
    </div>
